module.exports = __webpack_public_path__ + "static/media/hydrafacial.f0d8f155.png";